import { render, staticRenderFns } from "./DownloadCorrectiveTicket.vue?vue&type=template&id=6d0b3755&"
import script from "./DownloadCorrectiveTicket.vue?vue&type=script&lang=js&"
export * from "./DownloadCorrectiveTicket.vue?vue&type=script&lang=js&"
import style0 from "./DownloadCorrectiveTicket.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports